<template >
  <span>
    <template v-if="loaded">
    <eadForm  v-if="['h4', 'L2-case'].indexOf(formtype)>-1" /> 
    <gcform  v-else-if="formtype=='gc'" />
    <sponsorQuestionnaire  v-else-if="formtype=='I-130' && checkSponsorLogin" />
    <petitionerQuestionnaire  v-else-if="formtype=='L-visa' && redirectQuestionnaire == false" />
    <petitionform  v-else-if="(['h4', 'gc', 'L2-case'].indexOf(formtype)<=-1 && !checkSponsorLogin) || formtype=='GCI-485' " />
  </template>
  </span>
</template>

<script>
import sponsorQuestionnaire from "./forms/sponsorQuestionnaire.vue";
//import petitionform from "./forms/petition.vue";
import petitionform from "./forms/case.vue";
import petitionerQuestionnaire from "./forms/petitionerQuestionnaire.vue";
import eadForm from "./forms/h4eadQuestionnaire.vue";
//import gcform from "./forms/gcform.vue";
import gcform from "./forms/case.vue";

export default {
  components: {
    petitionerQuestionnaire,
    petitionform,
    gcform,
    eadForm,
    sponsorQuestionnaire
  },
  data() {
    return {
      formtype:null,
      redirectBenQuestionnaire:false,
      redirectQuestionnaire:false,
      loaded:false
    }
  },
  mounted() {
    let currentRoute  = this.$route;
    let currentRouteName = _.get( currentRoute,'name' ,'');
    console.log(this.$route.query)
   
    if((this.$route.params && this.$route.params.redirectBenQuestionnaire) || (this.$route.query && this.$route.query.redirectBenQuestionnaire)){
      
      this.redirectBenQuestionnaire = true;
    }
    if((this.$route.params && this.$route.params.redirect) || currentRouteName == 'fill-questionnaire' || (this.$route.query && this.$route.query.redirect)){
      
      this.redirectQuestionnaire = true;
    }

    this.$store
      .dispatch("getpetition", this.$route.params.itemId)
      .then((response) => {
        if (response && response.data && response.data.result) {
          if(this.checkProperty( response.data.result ,'subTypeDetails' ,'id') == 17){
            this.formtype = "gc"
          }else if([2,10].indexOf(this.checkProperty( response.data.result ,'typeDetails' ,'id')) >-1){
            this.formtype = "h4"
          }
          else if([18].indexOf(this.checkProperty( response.data.result ,'subTypeDetails' ,'id')) >-1){
            this.formtype = "I-130"
          }
          else if([5].indexOf(this.checkProperty( response.data.result ,'typeDetails' ,'id')) >-1){
            this.formtype = "L-visa"
          }
          else if([19].indexOf(this.checkProperty( response.data.result ,'subTypeDetails' ,'id')) >-1){
            this.formtype = "GCI-485"
          }
          else if([11].indexOf(this.checkProperty( response.data.result ,'typeDetails' ,'id')) >-1){
            this.formtype = "L2-case"
          }
          if(this.formtype=='I-130' && this.checkSponsorLogin && this.redirectBenQuestionnaire == false){
            this.$router.push({ name: "sponsor-questionnaire", params: { itemId: this.$route.params.itemId } });
          }
          if(this.formtype=='L-visa' && this.redirectQuestionnaire == false){
            this.$router.push({ name: "petitioner-questionnaire", params: { itemId: this.$route.params.itemId, 'redirect': false  } });
          }
         
        }
        this.loaded = true
      }).catch((err)=>{
        this.loaded = true
      })
  },
  computed:{
    checkSponsorLogin(){
      let loginData = this.$store.state.loginUserData;
      let returnVal = false;
      if(this.checkProperty(loginData,'accountType') && this.checkProperty(loginData,'accountType')=='Individual' && 
      this.checkProperty(loginData,'accountSubType') && this.checkProperty(loginData,'accountSubType')=='Sponsor' && [51].indexOf(this.getUserRoleId)>-1 &&  this.redirectBenQuestionnaire == false){
        returnVal = true
      }
      return returnVal
    }
  }
};
</script>